import LandingPage from 'landing_pages/containers';
import landingPageReducer from 'landing_pages/ducks';

export { landingPageReducer };
export default LandingPage;
